import axiosInstance from "../../../config/axios"
import { statusValidator } from "../../../kernel/validators/status.validator";
import router from "../../../router/index";

const BASE_URL_USER = "/user"
const BASE_URL_LOGGED = "/logged"

const Operations = {
    async newUser(url, data){
      let response;
      try {
        response = await axiosInstance.post(`${BASE_URL_USER}${url}`, data);
        response = statusValidator(response);
      } catch (error) {
        if(error.response){
          response = statusValidator(error.response);
        }else{
          router.push({name: 'Error Error500'})
        }
      }
      return response;
    },

    async lisUsers(url){
      let response;
      try {
        response = await axiosInstance.get(`${BASE_URL_USER}${url}`);
        response = statusValidator(response);
      } catch (error) {
        if(error.response){
          response = statusValidator(error.response);
        }else{
          router.push({name: 'Error Error500'})
        }
      }
      return response;
    },

    async listConsumers(url){
      let response;
      try {
        response = await axiosInstance.get(`${BASE_URL_USER}${url}`);
        response = statusValidator(response);
      } catch (error) {
        if(error.response){
          response = statusValidator(error.response);
        }else{
          router.push({name: 'Error Error500'})
        }
      }
      return response;
    },

    async getUser(url, data){
      let response;
      try {
        response = await axiosInstance.put(`${BASE_URL_USER}${url}`, data);
        response = statusValidator(response);
      } catch (error) {
        if(error.response){
          response = statusValidator(error.response);
        }else{
          router.push({name: 'Error Error500'})
        }
      }
      return response;
    },

    async updateUser(url, data){
      let response;
      try {
        response = await axiosInstance.put(`${BASE_URL_USER}${url}`, data);
        response = statusValidator(response);
      } catch (error) {
        if(error.response){
          response = statusValidator(error.response);
        }else{
          router.push({name: 'Error Error500'})
        }
      }
      return response;
    },

    async changeStatusUser(url, data){
      let response;
      try {
        response = await axiosInstance.put(`${BASE_URL_USER}${url}`, data);
        response = statusValidator(response);
      } catch (error) {
        if(error.response){
          response = statusValidator(error.response);
        }else{
          router.push({name: 'Error Error500'})
        }
      }
      return response;
    },

    async getDetailDriver(url, data){
      let response;
      try {
        response = await axiosInstance.put(`${BASE_URL_LOGGED}${url}`, data);
        response = statusValidator(response);
      } catch (error) {
        if(error.response){
          response = statusValidator(error.response);
        }else{
          router.push({name: 'Error Error500'})
        }
      }
      return response;
    },
    
    async deleteUser(param, data) {
      let response;
      try {
        let rawId = param;
        if (typeof param === "object" && param !== null) {
          rawId = param.id;
        } else if (data) {
          rawId = data.id || data;
        }

        const cleanId = String(rawId).replace(/\//g, "").trim();

        response = await axiosInstance.delete(`${BASE_URL_USER}/${cleanId}`);
        // Solo valida estatus si la respuesta fue exitosa (200 OK)
        if (response && response.status === 200) {
          return statusValidator(response);
        }
        return { error: true, data: response?.data };
      } catch (error) {
        // En lugar de redirigir a /error404, retorna el mensaje para mostrarlo en SweetAlert
        if (error.response) {
          const errorData = error.response.data;
          return {
            error: true,
            data: {
              text: errorData?.text || errorData?.message || "El usuario ya no existe o no se pudo eliminar."
            }
          };
        }
        return { error: true, data: { text: "Error de conexión con el servidor." } };
      }
    }
}

export default Operations;